<template>
  <el-card
    class="account-remittance-not-account business-handling my-card"
    :body-style="cardBody"
  >
    <el-page-header>
      <template slot="content"
        ><span style="font-size:14px">{{
          $t("partnerTransfers")
        }}</span></template
      >
    </el-page-header>
    <div class="form-container">
      <el-divider content-position="left">
        <el-form
          inline
          ref="queryForm"
          :model="queryForm"
          :rules="rules"
          style="height:45px;overflow:hidden;"
        >
          <el-form-item
            :label="$t('accountInfo')"
            prop="param"
            style="margin-bottom:0"
          >
            <el-input
              size="mini"
              v-model="queryForm.param"
              :placeholder="$t('inputPhoneOrAccount')"
            ></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom:0">
            <el-button
              size="mini"
              type="primary"
              @click="onQuery('queryForm')"
              >{{ $t("queryAccountInfo") }}</el-button
            >
          </el-form-item>
        </el-form>
      </el-divider>
      <!-- 存款信息 -->
      <el-form
        v-if="remitterInfo"
        ref="addForm"
        :model="addForm"
        :rules="rules"
        label-position="top"
      >
        <el-input
          type="hidden"
          size="medium"
          v-model="remitterInfo.businessCode"
          disabled
        ></el-input>
        <el-row :gutter="20">
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('firstName')">
              <el-input
                size="medium"
                v-model="remitterInfo.firstName"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('lastName')">
              <el-input
                size="medium"
                v-model="remitterInfo.lastName"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('phone')">
              <el-input
                size="medium"
                v-model="remitterInfo.phone"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('idNumber')">
              <el-input
                size="medium"
                v-model="remitterInfo.idCard"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('accountAmount')">
              <el-input
                size="medium"
                v-model="remitterInfo.accountAmount"
                disabled
              >
                <template slot="prepend"
                  ><i
                    class="iconfont iconruishifalang"
                    style="font-size:14px"
                  ></i>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('account')">
              <el-input
                size="medium"
                v-model="remitterInfo.cardNo"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">{{ $t("partnerInfo") }}</el-divider>
        <el-row :gutter="20">
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('amountTransfer')" prop="amount">
  <el-input
    type="text"
    size="medium"
    v-model="addForm.amount"
    @input="onAmountInput"
  >
    <template slot="prepend">
      <i class="iconfont iconruishifalang" style="font-size: 14px"></i>
    </template>
  </el-input>
</el-form-item>
          </el-col>
<!-- Bank select -->
<el-col :md="24" :lg="18" :xl="12">
  <el-form-item :label="$t('bankName')" prop="bankId1">
    <div class="bank-selection">
      <!-- Banque 1 — toujours visible -->
      <div class="bank-row">
        <el-select
          size="medium"
          v-model="addForm.bankId1"
          filterable
          :placeholder="$t('selectBank')"
          style="width: 45%"
          @change="onBankChange"
        >
          <el-option
            v-for="item in availableBanksFor(1)"
            :key="item.id"
            :label="item.bankName + ' — FCFA ' + Number(item.accountAmount || 0).formatMoney(0)"
            :value="item.id"
          />
        </el-select>
        <span class="bank-amount" v-if="getBankById(addForm.bankId1)">
          Dispo: FCFA {{ Number(getBankById(addForm.bankId1).accountAmount || 0).formatMoney(0) }}
        </span>
        <span class="bank-amount-used" v-if="addForm.bankId1">
          Utilisé: FCFA {{ Number(amountFromBank1 || 0).formatMoney(0) }}
        </span>
      </div>

      <!-- Bank 2 — -->
      <div class="bank-row" v-if="needsBank2">
        <el-select
          size="medium"
          v-model="addForm.bankId2"
          filterable
          :placeholder="$t('selectBank')"
          style="width: 45%"
          @change="onBankChange"
        >
          <el-option
            v-for="item in availableBanksFor(2)"
            :key="item.id"
:label="item.bankName + ' — FCFA ' + Number(item.accountAmount || 0).formatMoney(0)"
            :value="item.id"
          />
        </el-select>
        <span class="bank-amount" v-if="getBankById(addForm.bankId2)">
          Dispo: FCFA {{ Number(getBankById(addForm.bankId1).accountAmount || 0).formatMoney(0) }}
        </span>
        <span class="bank-amount-used" v-if="addForm.bankId2">
          Utilisé: FCFA {{ Number(amountFromBank1 || 0).formatMoney(0) }}
        </span>
      </div>

      <!-- Bank 3 — -->
      <div class="bank-row" v-if="needsBank3">
        <el-select
          size="medium"
          v-model="addForm.bankId3"
          filterable
          :placeholder="$t('selectBank')"
          style="width: 45%"
          @change="onBankChange"
        >
          <el-option
            v-for="item in availableBanksFor(3)"
            :key="item.id"
:label="item.bankName + ' — FCFA ' + Number(item.accountAmount || 0).formatMoney(0)"
            :value="item.id"
          />
        </el-select>
        <span class="bank-amount" v-if="getBankById(addForm.bankId3)">
          Dispo: FCFA {{ Number(getBankById(addForm.bankId1).accountAmount || 0).formatMoney(0) }}
        </span>
        <span class="bank-amount-used" v-if="addForm.bankId3">
          Utilisé: FCFA {{ Number(amountFromBank1 || 0).formatMoney(0) }}
        </span>
      </div>

      <!-- summarised -->
      <div class="bank-summary" v-if="addForm.bankId1 && amountNumber">
  <span :class="isBankAmountSufficient ? 'sufficient' : 'insufficient'">
    Total dispo: FCFA {{ Number(totalBankAmount).formatMoney(0) }}
    / Montant: FCFA {{ Number(amountNumber).formatMoney(0) }}
    {{ isBankAmountSufficient ? '✅' : '❌ Insuffisant' }}
  </span>
</div>
    </div>
  </el-form-item>
</el-col>
</el-row>


<el-row :gutter="20">
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('partnerApplyCode')" prop="transferCode">
              <el-input size="medium" v-model="addForm.transferCode"></el-input>
            </el-form-item>
          </el-col>

          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item
              :label="$t('transferDatePartner')"
              prop="transferDate"
            >
              <el-date-picker
                v-model="addForm.transferDate"
                type="datetime"
                :time-arrow-control="true"
                :format="'yyyy-MM-dd HH:mm:ss'"
                :placeholder="$t('selectDateAndTime')"
                style="width:100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

        <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('partnerReason')" prop="partnerReason">
          <el-input
            type="textarea"
            size="medium"
            v-model="addForm.partnerReason"
          ></el-input>
        </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="bottom-button" v-if="remitterInfo">
      <el-button
        size="medium"
        :loading="isLoading"
        type="primary"
        @click="onSubmit('addForm')"
        >{{ $t("submit") }}</el-button
      >
    </div>
  </el-card>
</template>

<script>
import customer from "@/api/customer";
//import transactionInfo from "@/api/transactionInfo";
import bank from "@/api/bank";
import manba from "@/assets/uilt/manbaDate";

//
export default {
  components: {},
  data() {
    return {
      isLoading: false,

      /**查询存款人信息 */
      queryForm: {},
      /**存款人信息 */
      remitterInfo: null,
      /**存款信息 */
      addForm: {
        amount: "",
  bankId1: null,
  bankId2: null,
  bankId3: null,
  transferCode: "",
  transferDate: "",
  partnerReason: "",

      },
      bankList: [],
    };
  },
  computed: {
    cascader() {
      return this.$store.state.format.cascader;
    },
    cardBody() {
      return this.$store.state.style.cardBody;
    },
    countryTree() {
      return this.$store.state.globalParameter.countryTree;
    },
    rules() {
      return {
        bankId1: [
  { required: true, message: this.$t("requiredFields"), trigger: "change" },
  {
    validator: (rule, value, callback) => {
      if (!value) return callback(new Error(this.$t("requiredFields")));
      if (!this.isBankAmountSufficient)
        return callback(new Error(this.$t("300008:not sufficient funds")));
      callback();
    },
    trigger: "change",
  },
],
        transferCode: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        transferDate: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        amount: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
      };
    },
    needsBank2() {
  if (!this.addForm.bankId1 || !this.addForm.amount) return false;
  const bank1 = this.getBankById(this.addForm.bankId1);
  if (!bank1) return false;
  return parseFloat(bank1.accountAmount) < this.amountNumber;
},

needsBank3() {
  if (!this.needsBank2 || !this.addForm.bankId2) return false;
  const bank1 = this.getBankById(this.addForm.bankId1);
  const bank2 = this.getBankById(this.addForm.bankId2);
  if (!bank1 || !bank2) return false;
  return (parseFloat(bank1.accountAmount) + parseFloat(bank2.accountAmount))
    < this.amountNumber;
},

totalBankAmount() {
  let total = 0;
  if (this.addForm.bankId1) {
    const b = this.getBankById(this.addForm.bankId1);
    if (b) total += parseFloat(b.accountAmount || 0);
  }
  if (this.addForm.bankId2) {
    const b = this.getBankById(this.addForm.bankId2);
    if (b) total += parseFloat(b.accountAmount || 0);
  }
  if (this.addForm.bankId3) {
    const b = this.getBankById(this.addForm.bankId3);
    if (b) total += parseFloat(b.accountAmount || 0);
  }
  return total;
},

amountFromBank1() {
  if (!this.addForm.bankId1 || !this.addForm.amount) return 0;
  const bank1 = this.getBankById(this.addForm.bankId1);
  if (!bank1) return 0;
  const amount = this.amountNumber;
  return Math.min(parseFloat(bank1.accountAmount || 0), amount);
},

amountFromBank2() {
  if (!this.addForm.bankId2 || !this.addForm.amount) return 0;
  const bank1 = this.getBankById(this.addForm.bankId1);
  const bank2 = this.getBankById(this.addForm.bankId2);
  if (!bank2) return 0;
  const amount = this.amountNumber;
  const remaining = amount - parseFloat(bank1 ? bank1.accountAmount : 0);
  return Math.max(0, Math.min(parseFloat(bank2.accountAmount || 0), remaining));
},

amountFromBank3() {
  if (!this.addForm.bankId3 || !this.addForm.amount) return 0;
  const bank1 = this.getBankById(this.addForm.bankId1);
  const bank2 = this.getBankById(this.addForm.bankId2);
  const bank3 = this.getBankById(this.addForm.bankId3);
  if (!bank3) return 0;
  const amount =  this.amountNumber;
  const remaining = amount
    - parseFloat(bank1 ? bank1.accountAmount : 0)
    - parseFloat(bank2 ? bank2.accountAmount : 0);
  return Math.max(0, Math.min(parseFloat(bank3.accountAmount || 0), remaining));
},
amountNumber() {
    return parseFloat(String(this.addForm.amount || "0").replace(/\s/g, "")) || 0;
  },
isBankAmountSufficient() {
  return this.totalBankAmount >= this.amountNumber;
},
  },
  watch: {
  "addForm.amount"() {
    this.onBankChange();
  },
},
  methods: {
    onQuery(refName) {
      let _this = this;
      this.$refs[refName].validate((valid) => {
        if (valid) {
          let p = {};
          if (_this[refName].param.length === 15)
            p.cardNo = _this[refName].param;
          else p.phone = _this[refName].param;

          customer.getPartnerByAccountOrPhone({
            param: p,
            success: (res) => {
              if (res.code != 200) {
                _this.$message.warning(_this.$t(res.msg));
                return;
              }
              _this.remitterInfo = {
                businessCode: _this.$route.params.code,
                firstName: res.data.name,
                lastName: res.data.surname,
                phone: res.data.phoneNo,
                idCard: res.data.idCard,
                accountAmount: res.data.accountAmount,
                cardNo: res.data.cardNo,
                cardId: res.data.cardId,
              };
            },
          });
        } else return false;
      });
    },
    getBankList() {
      let _this = this;
      bank.getAllBank({
        success: (res) => {
          if (res.code != 200) return;
          _this.bankList = res.data;
        },
      });
    },
    getBankById(id) {
  if (!id) return null;
  return this.bankList.find(b => b.id === id) || null;
},

onAmountInput(val) {
  const raw = String(val || "").replace(/\D/g, "");
  this.addForm.amount = raw
    ? raw.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    : "";
},
availableBanksFor(slot) {
  const selected = [
    slot !== 1 ? this.addForm.bankId1 : null,
    slot !== 2 ? this.addForm.bankId2 : null,
    slot !== 3 ? this.addForm.bankId3 : null,
  ].filter(Boolean);

  return this.bankList.filter(b =>
    b.status === 0 && !selected.includes(b.id)
  );
},

onBankChange() {
  if (!this.needsBank2) {
    this.addForm.bankId2 = null;
    this.addForm.bankId3 = null;
  }
  if (!this.needsBank3) {
    this.addForm.bankId3 = null;
  }
},

    onSubmit(refName) {
      let _this = this;
      _this.$refs[refName].validate((valid) => {
        if (!valid) return false;
        _this.isLoading = true;

        const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

        let p = Object.assign({}, _this.addForm, {
          amount: _this.amountNumber,
  phone:       _this.remitterInfo.phone,
  bankId:      _this.addForm.bankId1,
  bankId2:     _this.addForm.bankId2 || null,
  bankId3:     _this.addForm.bankId3 || null,
  amountBank1: round2(_this.amountFromBank1),
  amountBank2: round2(_this.amountFromBank2),
  amountBank3: round2(_this.amountFromBank3),
  transferDate: manba(_this.addForm.transferDate).format("ymdhms"),
});

        _this[refName].transferDate = manba(_this[refName].transferDate).format(
          "ymdhms",
        );
        bank.partnerDeposit({
          param: p,
          success: (res) => {
            if (res.code == 200) {
              _this.$message.success(_this.$t("operateSuccessfully"));

              _this.remitterInfo = {
                businessCode: "",
                firstName: "",
                lastName: "",
                phone: "",
                idCard: "",
                accountAmount: "",
                cardNo: "",
                cardId: "",
              };
              _this.addForm = {
                transferCode: "",
                transferDate: "",
                partnerReason: "",
                amount: "",
                bankId1: null,   
  bankId2: null,
  bankId3: null,
                phone: "",
              };
              _this.queryForm = {
                param: "",
              };
              _this.getBankList();
            } else {
              _this.$message.warning(_this.$t(res.msg));
            }
            _this.isLoading = false;
          },
        });
      });
    },
  },
  mounted() {
    this.getBankList();
  },
};
</script>

<style lang="less" scoped>
.account-remittance-not-account.business-handling {
  height: 100%;
  width: 100%;
  .el-card__body {
    position: relative;
    .form-container {
      position: absolute;
      top: 60px;
      bottom: 80px;
      left: 20px;
      right: 0;
      padding-right: 20px;
      overflow: auto;
    }
  }
  .el-form {
    height: auto;
  }
  .bank-selection {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.bank-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.bank-amount {
  color: #909399;
  font-size: 13px;
}
.bank-amount-used {
  color: #1164C4;
  font-size: 13px;
  font-weight: 600;
}
.bank-summary {
  margin-top: 8px;
  font-size: 13px;
}
.sufficient { color: #67C23A; font-weight: 600; }
.insufficient { color: #F56C6C; font-weight: 600; }
}

</style>
